angular.module('impactx.list').controller('ListActionCtrl', ['$scope', '$securityManager', ListActionCtrl]);

function ListActionCtrl($scope, $securityManager)
{
    $scope.isProcessAllowed = function(process)
    {
        return $securityManager.isProcessAllowed(process);
    };
}